import mod from "-!./Confirmation.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./Confirmation.js?vue&type=script&lang=js&external"